<template>
	<v-card>
		<v-card-title>
			<h2>Raporty</h2>
		</v-card-title>
		<v-card-text>
			<volunteer-report-table/>
		</v-card-text>
	</v-card>
</template>

<script>
	import VolunteerReportTable from "./VolunteerReportTable";

	export default {
		name: "ReportView",
		components: {VolunteerReportTable}
	};
</script>
